import React from "react";
import AboutClasses from "./about.module.css";
import Person from "Assets/Homepage/OurMission/person.png";
import Star from "Assets/Homepage/OurMission/start.png";
import Icon1 from "Assets/Homepage/OurMission/icon_1.png";
function About() {
    return (
        <div className={AboutClasses["Container"]}>
            <h3>
                Our mission is to produce the highest quality work for every
                client, on every project
            </h3>
            <div className={AboutClasses["content-wrapper"]}>
                <div className={AboutClasses["img-wrapper"]}>
                    {/* <p>dsf</p> */}
                    <img
                        src={Person}
                        alt="Person"
                        className={AboutClasses["person"]}
                    />
                    <img
                        src={Star}
                        alt="Person"
                        className={AboutClasses["Star"]}
                    />
                </div>
                <div className={AboutClasses["icons"]}>
                    <div className={AboutClasses["icon"]}>
                        <div className={AboutClasses["icon-wrapper"]}>
                            <img src={Icon1} alt="Icon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;
